/**
 * 车辆诊断设备状态变更表格信息(昆仑山设备)
 */
import React, { useState, useEffect, Fragment } from 'react';
import CommonTable from '@/components/commonTable';
import ExportButton from '@/components/exportButton';
import {
  carDiagnosisDeviceRequest,
  carDiagnosisDeviceRequestPath
} from '@/service/carDiagnosis';
import { useTable } from '@/utils/useTable';
import { getKlsDeviceStatusColumns } from '@/columns/klsDeviceStatus';

interface KlsDeviceTableProps {
  diagnosisSearchParams: any;
  getExportParams: () => any;
  isKlsV3: boolean;
}

const KlsDeviceTable = (props: KlsDeviceTableProps) => {
  const { diagnosisSearchParams, getExportParams, isKlsV3 } = props;
  const [searchParams, setSearchParams] = useState(diagnosisSearchParams);
  // 监听搜索参数的变化重新获取数据
  useEffect(() => {
    setSearchParams(diagnosisSearchParams);
  }, [diagnosisSearchParams]);

  const { page, limit, loading, data, totalCount, onPageChange } = useTable({
    requestFunc: carDiagnosisDeviceRequest,
    initRequest: Boolean(diagnosisSearchParams),
    initPageSize: 40,
    searchParams
  });

  return (
    <Fragment>
      <div style={{ margin: '12px 0', textAlign: 'right' }}>
        <ExportButton
          type="primary"
          disabled={!diagnosisSearchParams}
          url={carDiagnosisDeviceRequestPath}
          fileName={`${diagnosisSearchParams?.plateNumber}设备状态变更`}
          getParamsFunc={getExportParams}
          requestMethod="GET"
          permissionKey="/car-admin/car-diagnosis/device-status-export"
        />
      </div>
      <CommonTable
        rowKey="id"
        columns={getKlsDeviceStatusColumns(data, isKlsV3)}
        dataSource={data}
        pagination={{
          total: totalCount,
          current: page,
          pageSize: limit,
          onChange: onPageChange
        }}
        bordered
        loading={loading}
        scroll={{ x: '100%', y: 400 }}
      />
    </Fragment>
  );
};

export default KlsDeviceTable;
